import { generator } from '@philips-emr/tws-core/lib/client/event-listener';

const HPMSOnMountFormVisitTechnical = generator('onMountFormVisitTechnical');

export {
  HPMSOnMountFormVisitTechnical,
};

